<app-side-menu>
  <div class="stock-movements-form-container">
    <!-- Header (criar / editar) -->
    <div class="page-header" *ngIf="!isViewMode">
      <div class="header-content">
        <h1 class="page-title">
          <i class="fas fa-exchange-alt"></i>
          {{ pageTitle }}
        </h1>
        <p class="page-subtitle">Gerencie movimentações de estoque</p>
      </div>
    </div>

    <!-- Visualização: layout documento (estilo dashboard) -->
    <div class="mv-page" *ngIf="isViewMode && movement">
      <div class="mv-shell">
        <div class="mv-card">
          <header class="mv-header">
            <div class="mv-header__title">
              <div class="mv-header__icon" aria-hidden="true">
                <i class="fas fa-eye"></i>
              </div>
              <div>
                <h1 class="mv-header__h1">
                  Detalhes da movimentação
                  <span class="mv-header__id">#{{ movement.id }}</span>
                </h1>
                <p class="mv-header__sub" *ngIf="getViewHeaderItemSubtitle(movement) as sub">{{ sub }}</p>
              </div>
            </div>
            <div class="mv-badge" [ngClass]="'mv-badge--' + getViewStatusBadgeVariant(movement)">
              <span class="mv-badge__dot" *ngIf="getViewStatusBadgeVariant(movement) === 'amber'"></span>
              <span>{{ getStatusViewLabel(movement.status) }}</span>
            </div>
          </header>

          <div class="mv-body">
            <!-- Stepper -->
            <div class="mv-stepper" [attr.aria-label]="'Progresso do envio'">
              <div class="mv-stepper__track">
                <div class="mv-stepper__line-bg"></div>
                <div class="mv-stepper__line-active" [style.width.%]="getViewStepperProgress(movement)"></div>
                <div class="mv-stepper__nodes">
                  <div class="mv-stepper__node" [ngClass]="'mv-stepper__node--' + getViewStepKind(0, movement)">
                    <div class="mv-stepper__circle">
                      <i class="fas fa-check" *ngIf="getViewStepKind(0, movement) === 'done'"></i>
                      <span *ngIf="getViewStepKind(0, movement) === 'current'">1</span>
                    </div>
                    <span class="mv-stepper__label">Solicitado</span>
                  </div>
                  <div class="mv-stepper__node" [ngClass]="'mv-stepper__node--' + getViewStepKind(1, movement)">
                    <div class="mv-stepper__circle">
                      <i class="fas fa-shipping-fast" *ngIf="getViewStepKind(1, movement) === 'current'"></i>
                      <i class="fas fa-check" *ngIf="getViewStepKind(1, movement) === 'done'"></i>
                      <span *ngIf="getViewStepKind(1, movement) === 'upcoming'">2</span>
                    </div>
                    <span class="mv-stepper__label">{{ getViewStepperMidLabel(movement) }}</span>
                  </div>
                  <div class="mv-stepper__node" [ngClass]="'mv-stepper__node--' + getViewStepKind(2, movement)">
                    <div class="mv-stepper__circle">
                      <i class="fas fa-warehouse" *ngIf="getViewStepKind(2, movement) === 'current'"></i>
                      <i class="fas fa-check" *ngIf="getViewStepKind(2, movement) === 'done'"></i>
                      <span *ngIf="getViewStepKind(2, movement) === 'upcoming'">3</span>
                    </div>
                    <span class="mv-stepper__label">Recebimento</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mv-grid-2">
              <div class="mv-box mv-box--item">
                <div class="mv-box__icon-wrap">
                  <i class="fas fa-cube"></i>
                </div>
                <div class="mv-box__text">
                  <p class="mv-kicker">{{ getMovementTypeViewLabel(movement.movementType) }}</p>
                  <h2 class="mv-item-name">{{ getItemViewLabel(movement) }}</h2>
                  <div class="mv-qty-pill">
                    <span class="mv-qty-pill__muted">Quantidade</span>
                    <span class="mv-qty-pill__val">{{ movement.quantity | number:'1.0-4' }}</span>
                  </div>
                </div>
              </div>

              <div class="mv-box mv-box--route">
                <h3 class="mv-route__title">Rota de transferência</h3>
                <div class="mv-route">
                  <div class="mv-route__point">
                    <div class="mv-route__point-icon mv-route__point-icon--muted">
                      <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <span class="mv-route__tag">Origem</span>
                    <span
                      class="mv-route__name"
                      [class.mv-route__name--faint]="isWarehouseUninformed(movement.originWarehouseName) && isViewRouteOriginFallback(movement)">
                      {{ getViewRouteOriginDisplay(movement) }}
                    </span>
                  </div>
                  <div class="mv-route__arrow">
                    <i class="fas fa-long-arrow-alt-right"></i>
                    <span class="mv-route__transfer">{{ getRouteTransferDisplay(movement) }}</span>
                  </div>
                  <div class="mv-route__point">
                    <div class="mv-route__point-icon mv-route__point-icon--strong">
                      <i class="fas fa-warehouse"></i>
                    </div>
                    <span class="mv-route__tag">Destino</span>
                    <span class="mv-route__name mv-route__name--bold">{{ formatWarehouseName(movement.destinationWarehouseName) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mv-meta">
              <div class="mv-meta__cell">
                <span class="mv-meta__label"><i class="far fa-calendar-alt"></i> Data da movimentação</span>
                <span class="mv-meta__val">{{ formatDateTime(movement.movementDate) }}</span>
              </div>
              <div class="mv-meta__cell">
                <span class="mv-meta__label"><i class="far fa-user"></i> Responsável</span>
                <span class="mv-meta__val">{{ getStaffViewLabel(movement) }}</span>
              </div>
              <div class="mv-meta__cell">
                <span class="mv-meta__label"><i class="far fa-clock"></i> Criado em</span>
                <span class="mv-meta__val">{{ formatDateTime(movement.createdAt) }}</span>
              </div>
              <div class="mv-meta__cell">
                <span class="mv-meta__label"><i class="far fa-id-badge"></i> Criado por</span>
                <span class="mv-meta__val">{{ movement.createdBy || '—' }}</span>
              </div>
              <div class="mv-meta__cell mv-meta__cell--full">
                <span class="mv-meta__label">Requer aprovação?</span>
                <span class="mv-meta__val">
                  <span class="mv-pill mv-pill--no" *ngIf="!movement.requiresApproval">Não</span>
                  <span class="mv-pill mv-pill--yes" *ngIf="movement.requiresApproval">Sim</span>
                </span>
              </div>
              <div class="mv-meta__cell mv-meta__cell--full" *ngIf="movement.reason">
                <span class="mv-meta__label">Motivo</span>
                <span class="mv-meta__val mv-meta__val--block">{{ movement.reason }}</span>
              </div>
            </div>

            <div class="mv-notes">
              <h3 class="mv-notes__title">
                <i class="far fa-sticky-note"></i>
                Observações
              </h3>
              <p class="mv-notes__body">{{ movement.notes || '—' }}</p>
            </div>

            <div
              class="alert alert-primary d-flex flex-column flex-md-row flex-md-wrap align-items-md-center justify-content-md-between gap-3 mv-link-banner"
              *ngIf="canShowLinkPendingItemBanner(movement)">
              <div>
                <strong class="d-block mb-1">
                  <i class="fas fa-link me-2"></i>
                  Vincular item de estoque
                </strong>
                <span class="small">
                  Esta entrada ainda não está associada a um item cadastrado em <strong>Itens</strong>.
                  Use o vínculo para informar o <code>itemId</code> e avançar o fluxo (ex.: para <em>em trânsito</em>).
                </span>
              </div>
              <button
                type="button"
                class="btn btn-primary shrink-0"
                *appHasPermission="['StockMovements.Create', 'StockMovements.ManualEntry']"
                (click)="openLinkItemModal()"
                [disabled]="isLoading || linkItemSubmitting">
                <i class="fas fa-link me-2"></i>
                Vincular item…
              </button>
            </div>

            <div class="mv-actions">
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="onCancel()"
                [disabled]="isLoading">
                <i class="fas fa-arrow-left me-2"></i>
                Voltar
              </button>
              <button
                type="button"
                class="btn btn-dark"
                *ngIf="canRegisterEntryReceipt(movement)"
                (click)="goToRegisterReceipt()"
                [disabled]="isLoading">
                <i class="fas fa-clipboard-check me-2"></i>
                Registrar recebimento
              </button>
            </div>
          </div>
        </div>
      </div>

      <app-modal
        [isOpen]="showLinkItemModal"
        [title]="'Vincular item de estoque'"
        [size]="'md'"
        [closable]="!linkItemSubmitting"
        (close)="closeLinkItemModal()">
        <div *ngIf="showLinkItemModal">
          <p class="text-muted small mb-3">
            Entrada pendente <strong>#{{ linkItemModalPendingEntryId }}</strong>.
            {{ linkItemModalContext }}
          </p>
          <p class="small mb-2">
            Busque o item cadastrado e confirme. O backend atualiza o status após o vínculo.
          </p>
          <div class="input-group mb-2">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="linkItemSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Nome ou código do item..."
              [disabled]="linkItemSubmitting"
              (keyup.enter)="searchLinkItems()" />
            <button
              type="button"
              class="btn btn-outline-primary"
              [disabled]="linkItemSubmitting || linkItemSearchLoading"
              (click)="searchLinkItems()">
              <i class="fas fa-search" *ngIf="!linkItemSearchLoading"></i>
              <i class="fas fa-spinner fa-spin" *ngIf="linkItemSearchLoading"></i>
            </button>
          </div>
          <div class="list-group mb-3" *ngIf="linkItemSearchResults.length">
            <button
              type="button"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              *ngFor="let it of linkItemSearchResults"
              [class.active]="linkItemSelectedId === it.id"
              [disabled]="linkItemSubmitting"
              (click)="selectLinkSearchItem(it)">
              <span><strong>{{ it.code }}</strong> — {{ it.name }}</span>
              <i class="fas fa-check text-success" *ngIf="linkItemSelectedId === it.id"></i>
            </button>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-link p-0 mb-2"
            *ngIf="linkItemSelectedId"
            (click)="clearLinkItemSelection()"
            [disabled]="linkItemSubmitting">
            Limpar seleção
          </button>
        </div>
        <div slot="footer" class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" [disabled]="linkItemSubmitting" (click)="closeLinkItemModal()">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!linkItemSelectedId || linkItemSubmitting"
            (click)="submitLinkPendingItem()">
            <i class="fas fa-spinner fa-spin me-1" *ngIf="linkItemSubmitting"></i>
            Vincular
          </button>
        </div>
      </app-modal>
    </div>

    <!-- Formulário -->
    <div class="form-card" *ngIf="!isViewMode">
      <form [formGroup]="movementForm" (ngSubmit)="onSubmit()">
        
        <!-- Informações Básicas -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-info-circle"></i>
            Informações Básicas
          </h3>
          
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="itemSearch" class="form-label">Pesquisar item</label>
                <input
                  type="text"
                  id="itemSearch"
                  class="form-control mb-2"
                  [(ngModel)]="itemSearchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="onItemSearchChange()"
                  (keyup.enter)="searchItems()"
                  placeholder="Digite o nome do item (ex.: parafuso)">
                <div class="mb-2">
                  <app-button
                    text="Pesquisar"
                    [color]="'var(--primary-color)'"
                    [height]="'38px'"
                    (buttonClick)="searchItems()">
                  </app-button>
                </div>
                <input type="hidden" formControlName="itemId">
                <div class="border rounded p-2 bg-light small" *ngIf="movementForm.get('itemId')?.value">
                  Item selecionado:
                  <strong>{{ itemSearchTerm }}</strong>
                  <button type="button" class="btn btn-link btn-sm p-0 ms-2" (click)="clearSelectedItem()">Limpar</button>
                </div>
                <div class="list-group mt-2" *ngIf="!movementForm.get('itemId')?.value && itemSearchTerm.trim()">
                  <button
                    type="button"
                    class="list-group-item list-group-item-action"
                    *ngFor="let item of items"
                    (click)="selectSearchedItem(item)">
                    {{ item.code }} - {{ item.name }}
                  </button>
                  <div class="small text-muted p-2" *ngIf="!items?.length">
                    Nenhum item encontrado para a pesquisa.
                  </div>
                </div>
                <div class="invalid-feedback" *ngIf="hasError('itemId', 'required')">
                  {{ getErrorMessage('itemId') }}
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="movementType" class="form-label">Tipo de Movimentação *</label>
                <select
                  *ngIf="!isNewExitFlow"
                  id="movementType" 
                  class="form-select"
                  formControlName="movementType"
                  (change)="onMovementConfigChange()"
                  [class.is-invalid]="hasError('movementType', 'required')">
                  <option value="">Selecione o tipo</option>
                  <option *ngFor="let type of movementTypes" [value]="type.value">
                    {{ type.label }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('movementType', 'required')">
                  {{ getErrorMessage('movementType') }}
                </div>
                <div *ngIf="isNewExitFlow" class="form-control bg-light" aria-readonly="true">
                  Saída
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="movementSource" class="form-label">Origem da movimentação *</label>
                <select
                  id="movementSource"
                  class="form-select"
                  formControlName="movementSource"
                  (change)="onMovementConfigChange()"
                  [class.is-invalid]="hasError('movementSource', 'required')">
                  <option *ngFor="let source of movementSources" [value]="source.value">
                    {{ source.label }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('movementSource', 'required')">
                  {{ getErrorMessage('movementSource') }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="quantity" class="form-label">Quantidade *</label>
                <input 
                  type="number" 
                  id="quantity" 
                  class="form-control"
                  formControlName="quantity"
                  min="0.01"
                  step="0.01"
                  [class.is-invalid]="hasError('quantity', 'required') || hasError('quantity', 'min')">
                <div class="invalid-feedback" *ngIf="hasError('quantity', 'required') || hasError('quantity', 'min')">
                  {{ getErrorMessage('quantity') }}
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="movementDate" class="form-label">Data da Movimentação *</label>
                <input 
                  type="date" 
                  id="movementDate" 
                  class="form-control"
                  formControlName="movementDate"
                  [class.is-invalid]="hasError('movementDate', 'required')">
                <div class="invalid-feedback" *ngIf="hasError('movementDate', 'required')">
                  {{ getErrorMessage('movementDate') }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Almoxarifados -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-warehouse"></i>
            Almoxarifado
          </h3>
          <p class="text-muted small mb-3" *ngIf="movementForm.get('movementType')?.value === 'Saida'">
            Saída manual: a quantidade é baixada <strong>apenas</strong> do almoxarifado de origem. Não há transferência para outro almoxarifado.
          </p>
          <p class="text-muted small mb-3" *ngIf="movementForm.get('movementType')?.value === 'Entrada'">
            Indique o almoxarifado de <strong>destino</strong> onde a entrada será registrada.
          </p>
          
          <div class="row">
            <div class="col-md-6" *ngIf="movementForm.get('movementType')?.value === 'Saida'">
              <div class="form-group">
                <label for="originWarehouseId" class="form-label">
                  Almoxarifado de origem (baixa) *
                </label>
                <select 
                  id="originWarehouseId" 
                  class="form-select"
                  formControlName="originWarehouseId"
                  [class.is-invalid]="hasError('originWarehouseId', 'required')">
                  <option value="">Selecione o almoxarifado</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.code }} - {{ warehouse.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('originWarehouseId', 'required')">
                  {{ getErrorMessage('originWarehouseId') }}
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="movementForm.get('movementType')?.value === 'Entrada'">
              <div class="form-group">
                <label for="destinationWarehouseId" class="form-label">
                  Almoxarifado de destino (entrada) *
                </label>
                <select 
                  id="destinationWarehouseId" 
                  class="form-select"
                  formControlName="destinationWarehouseId"
                  [class.is-invalid]="hasError('destinationWarehouseId', 'required')">
                  <option value="">Selecione o almoxarifado</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.code }} - {{ warehouse.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="hasError('destinationWarehouseId', 'required')">
                  {{ getErrorMessage('destinationWarehouseId') }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detalhes -->
        <div class="form-section">
          <h3 class="section-title">
            <i class="fas fa-clipboard-list"></i>
            Detalhes
          </h3>
          
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="reason" class="form-label">Motivo *</label>
                <input 
                  type="text" 
                  id="reason" 
                  class="form-control"
                  formControlName="reason"
                  placeholder="Descreva o motivo da movimentação"
                  [class.is-invalid]="hasError('reason', 'required')">
                <div class="invalid-feedback" *ngIf="hasError('reason', 'required')">
                  {{ getErrorMessage('reason') }}
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="movementForm.get('movementType')?.value === 'Saida'">
            <div class="col-md-6">
              <div class="form-group">
                <label for="exitType" class="form-label">Tipo de saída *</label>
                <select id="exitType" class="form-select" formControlName="exitType">
                  <option *ngFor="let t of exitTypes" [value]="t.value">{{ t.label }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label d-block">Aprovação</label>
                <div class="form-check mt-2">
                  <input
                    type="checkbox"
                    id="requiresApproval"
                    class="form-check-input"
                    formControlName="requiresApproval">
                  <label for="requiresApproval" class="form-check-label">
                    Requer aprovação
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="notes" class="form-label">Observações</label>
                <textarea 
                  id="notes" 
                  class="form-control"
                  formControlName="notes"
                  rows="3"
                  placeholder="Observações adicionais sobre a movimentação"></textarea>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngIf="movementForm.get('movementSource')?.value === 'serviceOrder'">
            <div class="col-md-6">
              <div class="form-group">
                <label for="serviceOrderId" class="form-label">Ordem de Serviço vinculada *</label>
                <input 
                  type="number" 
                  id="serviceOrderId" 
                  class="form-control"
                  formControlName="serviceOrderId"
                  placeholder="ID da ordem de serviço relacionada"
                  [class.is-invalid]="hasError('serviceOrderId', 'required') || hasError('serviceOrderId', 'min')">
                <div class="invalid-feedback" *ngIf="hasError('serviceOrderId', 'required') || hasError('serviceOrderId', 'min')">
                  Informe um ID de OS válido.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botões -->
        <div class="form-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary me-2"
            (click)="onCancel()"
            [disabled]="isLoading">
            <i class="fas fa-times me-2"></i>
            Cancelar
          </button>
          
          <button 
            *ngIf="!isViewMode"
            type="submit" 
            class="btn btn-primary"
            [disabled]="movementForm.invalid || isLoading">
            <i class="fas fa-spinner fa-spin me-2" *ngIf="isLoading"></i>
            <i class="fas fa-save me-2" *ngIf="!isLoading"></i>
            {{ submitButtonText }}
          </button>
        </div>

      </form>
    </div>

    <!-- Loading Overlay -->
    <div *ngIf="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>

  </div>
</app-side-menu>